import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export function Input({
  label,
  error,
  className = '',
  id,
  ...props
}: InputProps) {
  const inputId = id || props.name;
  return <div className="w-full" data-id="element-133">
      {label && <label htmlFor={inputId} className="block text-sm font-bold text-charcoal mb-2 ml-1" data-id="element-134">
          {label}
        </label>}
      <input id={inputId} className={`w-full px-4 py-3 rounded-2xl border-2 border-gray-200 focus:border-teal focus:ring-0 transition-colors outline-none bg-gray-50 focus:bg-white ${error ? 'border-red-500' : ''} ${className}`} {...props} data-id="element-135" />
      {error && <p className="mt-1 text-sm text-red-500 ml-1" data-id="element-136">{error}</p>}
    </div>;
}
interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}
export function TextArea({
  label,
  error,
  className = '',
  id,
  ...props
}: TextAreaProps) {
  const inputId = id || props.name;
  return <div className="w-full" data-id="element-137">
      {label && <label htmlFor={inputId} className="block text-sm font-bold text-charcoal mb-2 ml-1" data-id="element-138">
          {label}
        </label>}
      <textarea id={inputId} className={`w-full px-4 py-3 rounded-2xl border-2 border-gray-200 focus:border-teal focus:ring-0 transition-colors outline-none bg-gray-50 focus:bg-white ${error ? 'border-red-500' : ''} ${className}`} {...props} data-id="element-139" />
      {error && <p className="mt-1 text-sm text-red-500 ml-1" data-id="element-140">{error}</p>}
    </div>;
}